import React, { useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { Rocket } from "lucide-react";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Coin, fmtK, fmtDate } from "@/lib/points";

export default function PromoteButton({ listing }) {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const [c, setC] = useState(null);
  const [kind, setKind] = useState("home");
  const [days, setDays] = useState(7);
  const [busy, setBusy] = useState(false);
  const open = () => api.get("/credits/info").then((r) => { setC(r.data); const on = Object.keys(r.data.promo).filter((k) => r.data.promo[k].on); setKind(on[0] || "home"); }).catch(() => toast.error("Nuk u ngarkua"));
  const price = Number(c?.promo?.[kind]?.price || 0);
  const total = Math.round(price * days * 100) / 100;
  const buy = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/credits/promote", { listing_id: listing.id, kind, days: Number(days) });
      toast.success(`U promovua deri më ${fmtDate(data.until)}`); setC(null);
      api.get("/auth/me").then((x) => setUser(x.data)).catch(() => {});
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <>
      <button data-testid={`promote-${listing.id}`} onClick={open} className="text-amber-600 p-2" aria-label="Promovo"><Rocket className="w-4 h-4" /></button>
      {c && createPortal(
        <div className="fixed inset-0 z-[9998] bg-black/50 flex items-end sm:items-center justify-center p-3" data-testid="promote-dialog" onClick={() => setC(null)}>
          <div className="bg-white rounded-3xl w-full max-w-sm p-5 space-y-3" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center gap-3"><Coin size={44} /><div><div className="font-extrabold text-slate-900">Promovo me GjejKredit</div><div className="text-xs text-slate-500 truncate">{listing.title}</div></div></div>
            <div className="grid gap-2">
              {Object.entries(c.promo_labels).filter(([k]) => c.promo[k]?.on).map(([k, l]) => (
                <button key={k} data-testid={`promote-kind-${k}`} onClick={() => setKind(k)} className={`rounded-2xl p-3 border-2 text-left text-sm ${kind === k ? "border-amber-400 bg-amber-50" : "border-slate-200"}`}>
                  <b>{l}</b><div className="text-xs text-slate-500">{fmtK(c.promo[k].price)} kredite / ditë</div>
                </button>
              ))}
            </div>
            <label className="block text-sm text-slate-700">Sa ditë?
              <input data-testid="promote-days" type="number" min="1" max="90" value={days} onChange={(e) => setDays(Math.max(1, Math.min(90, parseInt(e.target.value, 10) || 1)))} className="mt-1 w-full h-11 rounded-xl border border-slate-200 px-3" />
            </label>
            <div className="flex justify-between text-sm"><span>Gjithsej</span><b data-testid="promote-total">{fmtK(total)} kredite</b></div>
            <div className="flex justify-between text-xs text-slate-500"><span>Ke</span><span>{fmtK(c.balance)} kredite</span></div>
            {c.balance < total
              ? <><div className="rounded-2xl bg-rose-50 border border-rose-200 p-3 text-rose-700 text-sm font-semibold">🔴 Nuk keni GjejKredit të mjaftueshme. Ju duhen edhe {fmtK(total - c.balance)} kredite.</div>
                <button data-testid="promote-buy" onClick={() => nav("/gjejkredit/bli")} className="w-full h-11 rounded-xl bg-amber-500 text-white font-bold">Bli GjejKredit</button></>
              : <button data-testid="promote-confirm" disabled={busy} onClick={buy} className="w-full h-11 rounded-xl bg-emerald-500 text-white font-bold disabled:opacity-50">Paguaj {fmtK(total)} kredite</button>}
          </div>
        </div>,
        document.body,
      )}
    </>
  );
}
